var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cntr"},[_c('Header',{staticClass:"head"}),_c('ParameterDashboard',{staticClass:"param"}),_c('BeamlineDashboard',{staticClass:"bms"}),_c('HighChart',{staticClass:"chart"}),_c('MessageDashboard',{staticClass:"msg"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }